import Flex from '@eversports/react-components/primitives/Flex'
import RadioButton from '@eversports/react-components/primitives/RadioButton'
import Text from '@eversports/react-components/primitives/Text'
import PyroForm from 'pyro-form'
import React from 'react'

import { Localized } from '../../../localization/react'
import { PatronQuestionInitialValues } from '../../../typings/AdditionalInformation'

interface Props {
  initialValues: PatronQuestionInitialValues
  venueName: string
  handleChange: (values: PatronQuestionInitialValues) => void
}

const PatronQuestionComponent: React.FC<React.PropsWithChildren<Props>> = ({
  initialValues,
  venueName,
  handleChange,
}) => (
  <Flex flexDirection="column" verticalSpacing="default">
    <Text>
      <Localized id="additional-info-patron-question" params={{ venueName }} />
    </Text>
    <PyroForm initialValues={initialValues} onChange={handleChange}>
      <Flex flexDirection="column">
        <RadioButton
          name="isPatron"
          value={String(true)}
          label={<Localized id="yes" />}
          data-testid="patron-question-yes"
        />
        <RadioButton
          name="isPatron"
          value={String(false)}
          label={<Localized id="no" />}
          data-testid="patron-question-no"
        />
      </Flex>
    </PyroForm>
  </Flex>
)

export default PatronQuestionComponent
